/**
 * Extracts the session ID from the SDP.
 * Session ID is located in the o= line.
 * Ref: https://tools.ietf.org/html/rfc4566#section-5.2
 * @method getSdpSessionId
 * @param  {string} sdp A valid SDP string.
 * @return {string} The SDP's session ID.
 */
export function getSdpSessionId (sdp) {
  const oLine = sdp.match(/o=.*/gm)

  if (oLine && oLine[0]) {
    return oLine[0].split(' ')[1]
  }
}
